
export const GET_MENU_LIST = 'GET_MENU_LIST';
export const GET_TITLE_LIST = 'GET_TITLE_LIST';
export const GET_TENET_LIST = 'GET_TENET_LIST';
export const GET_VIDEO_LIST = 'GET_VIDEO_LIST';
export const GET_SODTODAY_LIST = 'GET_SODTODAY_LIST';
export const GET_INDUSTRY_LIST = 'GET_INDUSTRY_LIST';
export const GET_INDPRODUCT_LIST = 'GET_INDPRODUCT_LIST';
export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_TEAM_LIST = 'GET_TEAM_LIST';
export const GET_ADVERT_LIST = 'GET_ADVERT_LIST';
export const GET_BUISNESS_LIST = 'GET_BUISNESS_LIST';
export const GET_LIC_LIST = 'GET_LIC_LIST';
export const GET_PRESENTATION_LIST = 'GET_PRESENTATION_LIST';
export const GET_LEFTMENU_LIST = 'GET_LEFTMENU_LIST';
export const GET_SECTION_LIST = 'GET_SECTION_LIST';
export const GET_CONTACT_LIST = 'GET_CONTACT_LIST';
export const GET_COMP_MENU_LIST = 'GET_COMP_MENU_LIST';
export const GET_COMPANY_CONTENT = 'GET_COMPANY_CONTENT';
export const SEND_CONTACT_DATA = 'SEND_CONTACT_DATA';
export const GET_PRICE_TITLE  = 'GET_PRICE_TITLE';



// WEBPACK FOOTER //
// ./src/client/types/const.js